/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { lighten } from '@jiaminghi/color';

// export const StyledWrapper = styled.div`
//   width: 50px;
//   height: ${(props) => css`${props.size}`};
// `;
export const StyledWrapper = styled.section`
  display: flex;
  height: auto;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 16px;
  box-sizing: content-box;
`;

export const StyledTitle = styled.h4`
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 10px;
`;

export const StyledButtonsWrapper = styled.div`
  max-width: calc(50% + 50px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  margin-bottom: 10px;
`;

export const StyledInput = styled.input`
  width: auto;
  min-width: 40px;
  max-width: ${(props) => (props.readOnly ? '40px' : '60px')};
  padding: ${(props) => (props.readOnly ? '0' : '4px 8px')};
  margin: ${(props) => (props.readOnly ? '0' : '0 8px')};
  border: none;
  text-align: center;

  /* Hide number input spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  & + button::before {
    content: "+";
    padding-bottom: 0;
  }
`;

export const StyledButton = styled.button`${(props) => {
  const { fontFamily, fontSize, backgroundColor, borderColor, color } = props.customStyles;
  const hoverBC = lighten(borderColor, 10);

  return css`
    position: relative;
    font-family: ${fontFamily};
    font-size: ${fontSize};
    border: 1px solid ${borderColor};
    color: ${color};
    background-color: ${backgroundColor};
    border-radius: 5px;
    padding: 0;
    width: 30px;
    height: 30px;

    &:hover:not(:disabled) {
      background-color: ${hoverBC};
    }

    &:active:not(:disabled) {
      background-color: ${borderColor};
    }

    &:disabled {
      opacity: 0.3;
    }

    &::before {
      content: "-";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding-bottom: 2px;
    }
  `;
}}`;
